import { getCompanyTimezone } from '../../../utils/timezoneUtils';
import getSbmClient from '../../../utils/getSbmClient';
import moment from 'moment-timezone';

const getCynoMidnightTime = () => {
    const sbmApiClient = getSbmClient();
    const todayDateString = moment().set('day', 1).format("YYYY-MM-DD");
    const toZone = getCompanyTimezone(sbmApiClient);
    const fromZone = moment.tz.guess();

        
    const midnightTimeString = todayDateString.concat(" ", "24:00");
    const midnightTimeMoment = moment.tz(midnightTimeString, fromZone);
    const cynoMidnightTimeString = midnightTimeMoment.tz(toZone).format().split("T");
    const cynoMidnightTime = cynoMidnightTimeString[1].slice(0,5);

    return cynoMidnightTime.replace(":",'.');
}

export default getCynoMidnightTime;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/utils/getCynoMidnightTime.js